<app-tag
  *ngIf="tag"
  [ngClass]="{'secondary': tag.value === 'featured'}"
  [show]="show"
  [label]="tag.name"
  color="#fff"
  size="small">
</app-tag>
